var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M46.263 1.5L15.485 32.267 3.804 20.584a2 2 0 0 0-2.828-.002 2 2 0 0 0 0 2.829l14.5 14.513L49.09 4.317a2 2 0 0 0 0-2.827 2 2 0 0 0-2.828 0z","fill":"currentColor","fillRule":"nonzero"}));
}

TickInline.defaultProps = {"viewBox":"0 0 50 40"};

module.exports = TickInline;

TickInline.default = TickInline;
